import {Component, Inject, inject, OnDestroy, OnInit, PLATFORM_ID, signal} from "@angular/core";
import {LocationService} from "./services/location.service";
import {NgxUiLoaderModule} from "ngx-ui-loader";
import {ToastModule} from "primeng/toast";
import {Router, RouterModule} from "@angular/router";
import {MessageService} from "primeng/api";
import {SocialShareService} from "./services/social-share.service";
import {ScrollTopModule} from "primeng/scrolltop";
import {BrandColorService} from "./services/brand-color.service";
import {isPlatformBrowser} from "@angular/common";
import {BrowserService} from "./services/browser.service";

@Component({
    selector: "app-root",
    template: `
        <router-outlet></router-outlet>
        <a class="whatsapp-float"
           href="https://wa.me/919080501141"
           target="_blank"
           rel="noopener noreferrer"
           aria-label="Chat with us on WhatsApp"
           title="Chat with us on WhatsApp">
            <svg viewBox="0 0 32 32" aria-hidden="true" focusable="false">
                <path fill="currentColor" d="M16.04 3A12.88 12.88 0 0 0 5.06 22.63L3 29l6.58-2.05A12.91 12.91 0 1 0 16.04 3Zm0 23.61c-2.16 0-4.27-.64-6.06-1.84l-.43-.26-3.9 1.21 1.25-3.8-.28-.44a10.69 10.69 0 1 1 9.42 5.13Zm5.86-8.01c-.32-.16-1.9-.94-2.2-1.04-.29-.11-.5-.16-.72.16-.21.32-.82 1.04-1.01 1.26-.19.21-.37.24-.69.08-.32-.16-1.36-.5-2.58-1.6a9.66 9.66 0 0 1-1.79-2.23c-.19-.32-.02-.49.14-.65.15-.14.32-.37.48-.56.16-.18.21-.32.32-.53.11-.22.05-.4-.03-.56-.08-.16-.72-1.73-.98-2.37-.26-.62-.52-.54-.72-.55h-.61c-.21 0-.56.08-.85.4-.29.32-1.12 1.1-1.12 2.67s1.15 3.1 1.31 3.31c.16.21 2.26 3.45 5.47 4.84.76.33 1.36.52 1.83.67.77.24 1.47.21 2.02.13.62-.09 1.9-.78 2.17-1.53.27-.75.27-1.39.19-1.53-.08-.13-.29-.21-.61-.37Z"/>
            </svg>
        </a>
        <p-scrolltop class="position-absolute" [threshold]="100" icon="pi pi-arrow-up"
                     [buttonProps]="{ raised: true, rounded: true }"></p-scrolltop>
        <p-toast position="top-right"></p-toast>
        <ngx-ui-loader overlayColor="rgba(0,0,0,0.8)" logoUrl="uniprep-assets/images/icon-loader.svg" [bgsSize]="40"
                       bgsType="three-bounce" [bgsOpacity]="1" bgsColor="var(--p-secondary-500)" fgsOpacity="1"
                       fgsColor="var(--p-secondary-500)" [hasProgressBar]="false"></ngx-ui-loader>`,
    styles: [`
        .whatsapp-float {
            position: fixed;
            right: 24px;
            bottom: 88px;
            z-index: 1050;
            display: flex;
            width: 56px;
            height: 56px;
            align-items: center;
            justify-content: center;
            color: #fff;
            background: #25d366;
            border-radius: 50%;
            box-shadow: 0 4px 14px rgba(0, 0, 0, .25);
            transition: transform .2s ease, background-color .2s ease, box-shadow .2s ease;
        }

        .whatsapp-float:hover {
            color: #fff;
            background: #1ebe5d;
            box-shadow: 0 6px 18px rgba(0, 0, 0, .3);
            transform: translateY(-2px) scale(1.04);
        }

        .whatsapp-float:focus-visible {
            outline: 3px solid #fff;
            outline-offset: 3px;
        }

        .whatsapp-float svg {
            width: 32px;
            height: 32px;
        }

        @media (max-width: 575.98px) {
            .whatsapp-float {
                right: 16px;
                bottom: 80px;
                width: 52px;
                height: 52px;
            }

            .whatsapp-float svg {
                width: 30px;
                height: 30px;
            }
        }
    `],
    standalone: true,
    imports: [NgxUiLoaderModule, ToastModule, RouterModule, ScrollTopModule],
    providers: [MessageService, SocialShareService],
})
export class AppComponent implements OnInit, OnDestroy {
    isPageHidden = false;
    private visibilityChangeHandler!: () => void;
    constructor( private router: Router, @Inject(PLATFORM_ID) private platformId: Object) {
    }

    domainNameCondition!: string
    private locationService = inject(LocationService)
    private browserService = inject(BrowserService)
    private isInstitute = signal(false)

    ngOnInit() {
        if (this.isInstitute()) {
            if (this.browserService.locationHref.includes("/register")) {
                this.router.navigate(["/login"], {replaceUrl: true});
            }
        }
        let hostname = '';
        if (isPlatformBrowser(this.platformId)) {
            hostname = this.browserService.hostname
        }
        this.domainNameCondition = hostname;
        if (isPlatformBrowser(this.platformId)) {
            this.visibilityChangeHandler = () => {
                this.isPageHidden = this.browserService.isDocumentHidden;
            };
            this.browserService.onVisibilityChange(this.visibilityChangeHandler);
        }
    }

    private isDomainMain(): boolean {
        return this.domainNameCondition === "dev-institutes.uniprep.ai" || this.domainNameCondition === "institutes.uniprep.ai" || this.domainNameCondition === "partners.uniprep.ai" || this.domainNameCondition === "talent.uniprep.ai" || this.domainNameCondition === "dev-student.uniprep.ai" || this.domainNameCondition === "*.uniprep.ai" || this.domainNameCondition === "uniprep.ai" || this.domainNameCondition === "localhost";
    }

    ngOnDestroy(): void {
        if (isPlatformBrowser(this.platformId) && this.visibilityChangeHandler) {
            this.browserService.removeVisibilityChange(this.visibilityChangeHandler);
        }
    }
}
